import { ComponentProps } from 'react';
import {
  ToastHorizontal,
  ToastVertical,
  toastViewportClasses,
} from './toastViewportClasses/toastViewportClasses';

/**
 * Where a toast appears; it holds one ToastAlert. Presentation only.
 *
 * `aria-live` is on the region so a screen reader watches it before a toast
 * arrives. `polite` because toasts confirm; errors already get `role='alert'`
 * from the Alert.
 */
export const ToastViewport = ({
  vertical = 'top',
  horizontal = 'center',
  className,
  ...viewportProps
}: {
  vertical?: ToastVertical;
  horizontal?: ToastHorizontal;
} & ComponentProps<'div'>) => {
  return (
    <div
      aria-live='polite'
      className={toastViewportClasses({ vertical, horizontal, className })}
      {...viewportProps}
    />
  );
};
